<div class="container-box review-order-page" *ngIf="reviewModel !== null">
  <div>
    <h1 *ngIf="!isOrder">{{reviewTitle}}</h1>
    <h1 *ngIf="isOrder" class="order-confirm">{{confirmTitle}}</h1>

    <div class="alert valign-children-middle" *ngIf="errorMessage">
      <div class="alert-error" aria-label="Alert.">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div>
        <h2>Error!</h2>
        <p>{{ this.errorMessage }}</p>
      </div>
    </div>
    <div class="alert valign-children-middle" *ngIf="isOrder">
      <div class="alert-success" aria-label="checkmark">
        <i class="icon-approval" aria-hidden="true"></i>
      </div>
      <div>
        <h2>Thank you. We're completing your request.</h2>
      </div>
    </div>
  </div>
  <!-- Success Message Block Ends -->
  <section>
    <div class="mar-bot-20"><label class="data-label">Selected product: </label>{{reviewModel.product}}</div>
    <div><label class="data-label">Bill to:</label></div>
    <div *ngIf="!!reviewModel.fan"><label class="data-label">Foundation account number:</label> {{reviewModel.fan}}</div>
    <!--<div *ngIf="reviewModel.type === 'DiffCTN'"><label class="data-label">Billing account:</label> {{reviewModel.ban}}</div>-->
    <div><label class="data-label">Wireless number:</label> {{ reviewModel.ctn}}</div>
    <div class="mar-bot-20">{{reviewModel.description}}</div>
    <div class="order-id" *ngIf="isOrder"><strong>Order ID: </strong> {{reviewModel.id}}</div>
  </section>
  <h2 class="table-heading">
    <div class="row">
      <span class="col-sm-4 col-md-4">Product</span>
      <span class="col-sm-4 col-md-4 pull-right text-right"> Amount </span>
    </div>
  </h2>
  <div class="clearfix"></div>
  <hr/>
  <div class="product-details" *ngIf="reviewModel.type === 'RemoveAll'">
    <div class="row">
      <div class="col-sm-8 col-md-8">
        <p [innerHTML]='items.quantity1'> </p>
      </div>
      <div class="col-sm-4 col-md-4 text-right">
        <p class="price-value">{{reviewModel.initialAmount | currency:'USD':true:'1.2-3'}}</p>
        <p><small> per month </small></p>
      </div>
      <hr />
      <div class="col-sm-8 col-md-8">
        <span [innerHTML]='items.quantity2'></span>
      </div>
      <div class="col-sm-4 col-md-4 text-right">
        <p class="price-value">{{reviewModel.modifiedAmount | currency:'USD':true:'1.2-3'}}</p>
        <p><small> per month </small></p>
      </div>
    </div>
  </div>
  <div class="product-details" *ngIf="reviewModel.type !== 'RemoveAll'">
    <div class="row">
      <div class="col-sm-8 col-md-8">
        <!--<p [innerHTML]='items.quantity1'> </p>-->
        <p>{{reviewModel.totalLicense}} <span [innerHTML]="(reviewModel.totalLicense > 1)? 'licenses':'license'"></span> &#64; ${{reviewModel.unitPrice}}/user</p>
      </div>
      <div class="col-sm-4 col-md-4 text-right">
        <p class="price-value">{{reviewModel.unitTotalAmount | currency:'USD':true:'1.2-3'}}</p>
        <p class="last-text"><small> per month </small></p>
      </div>
    </div>

    <!--Estimated Discount -->
    <div *ngIf="reviewModel?.estimatedDiscount > 0" class="row est-discount no-top-margin">
      <div class="col-sm-8 col-md-6">
        <span class="est-img"> <i class="icon-retail-offers"></i> Estimated discount</span>
      </div>
      <div class="col-sm-4 col-md-6 text-right">
        <p class="price-value"> - {{reviewModel.estimatedDiscount|currency:'USD':true:'1.2-3'}}</p>
        <small> per month </small>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>

  <div *ngIf="reviewModel.type === 'changeProduct' && reviewModel.oneTimeFeeInfo.length > 0" class="product-details">
    <hr />
    <p>One-time charges</p>
    <ng-template let-charge ngFor [ngForOf]="reviewModel.oneTimeFeeInfo">
      <div class="row otc-line-items">
        <div class="col-sm-6 col-md-5">
          <p>{{charge.oneTimeFeeName}} </p>
        </div>
        <div class="col-sm-6 col-md-3 text-right">
          <p class="price-value" *ngIf="(!charge.customPrice) || (charge.customPrice === 0)">{{charge.unitPrice|currency:'USD':true:'1.2-3'}} </p>
          <p class="price-value" *ngIf="(charge.customPrice) && (charge.customPrice > 0)">{{charge.customPrice|currency:'USD':true:'1.2-3'}} </p>
          <small class="permonth"> one-time payment </small>
        </div>
      </div>
      <div class="row otc-line-items est-discount" *ngIf="(reviewModel.oneTimeFeeInfo.length) === 1 && (charge?.applicableDiscount > 0)">
        <div class="col-sm-7 col-md-5">
          <p class="est-img"><i class="icon-retail-offers"></i> Total Estimated discount</p>
        </div>
        <div class="col-sm-5 col-md-3 text-right">
          <p class="price-value"> - {{charge.applicableDiscount|currency:'USD':true:'1.2-3'}} </p>
          <small class="permonth"> one-time payment </small>
        </div>
      </div>
    </ng-template>
    <div *ngIf="(reviewModel.oneTimeFeeInfo.length > 1) && (reviewModel?.oneTimeFeeEstimatedDiscount > 0)" class="row  otc-line-items est-discount">
      <div class="col-sm-7 col-md-5">
        <span class="est-img"> <i class="icon-retail-offers"></i> Total estimated discount</span>
      </div>
      <div class="col-sm-5 col-md-3 text-right">
        <p class="price-value"> - {{reviewModel.oneTimeFeeEstimatedDiscount|currency:'USD':true:'1.2-3'}}</p>
        <small> one-time payment </small>
      </div>
      <div class="clearfix"></div>
    </div>

  </div>


  <div class="product-details">
    <hr/>
    <h2> Total charges*</h2>
    <div class="row">
      <div class="col-sm-8 col-md-8">
        <span> Total monthly charges</span>
      </div>
      <div class="col-sm-4 col-md-4 text-right ">
        <p class="total-price">{{reviewModel.totalAmount | currency:'USD':true:'1.2-3'}}</p>
        <!-- <p><small>per month</small></p>-->
      </div>
    </div>
    <div *ngIf="reviewModel.type === 'changeProduct'" class="row">
      <div class="col-sm-8 col-md-6">
        <span> Total one-time charges </span>
      </div>
      <div class="col-sm-4 col-md-6">
        <span class="total-price">{{reviewModel.oneTimeFee | currency:'USD':true:'1.2-3'}}</span>
      </div>
    </div>
  </div>
  <hr />
  <!-- Tnc new tab window -->
  <div class="tnc">
    <div *ngIf="reviewModel.type === 'DiffCTN' && reviewModel.type !== 'changeProduct'">
      <p *ngIf="!isOrder">{{tnctitle}} is subject to its <a [attr.aria-label]=" tnctitle + 'is subject to its Terms & Conditions (Opens in New Window)' "
          href="javascript:void(0)" (click)="showTermsCondition();">Terms & Conditions.</a></p>
    </div>
    <!-- tnc ends here -->
    <p> <small [innerHTML]="items.content"></small> </p>
  </div>
  <hr class="checkout-spacing" />
  <div class="checkout-area text-right">
    <button *ngIf="isOrder" class="btn btn-success btn-checkout pull-right manage-btn" (click)="manageProduct()"> Manage products </button>
    <div *ngIf="!isOrder">
      <button class="btn btn-success btn-checkout pull-right" [checkImpersonator]='csrPermissionReviewOrderSubmit' (click)="submitOrder()"> {{submitCaption}} </button>
      <a href="javascript:void(0)" class="btn btn-link btn-shopping" (click)="gotoPreviousPage()"> Back</a>
    </div>
  </div>
</div>
<div class="clearfix"></div>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>